import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { SleepingArrangement } from 'models';

import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkIconSize } from 'uitk-react-icons';

import { BeddingInfo } from 'components/infosite/property-sleeping-arrangements/internals/bedding-info';

export interface SpacesProps {
  isDialog?: boolean;
  sleepingArrangement?: SleepingArrangement;
}

export const Space: React.FunctionComponent<SpacesProps> = ({ isDialog, sleepingArrangement }) => {
  if (
    !sleepingArrangement ||
    !sleepingArrangement.sleepingArrangementLayouts ||
    sleepingArrangement.sleepingArrangementLayouts.length === 0
  ) {
    return null;
  }

  return (
    <UitkCard withBorder={true}>
      <UitkCardContent>
        <UitkCardTextSegment>
          {sleepingArrangement.sleepingArrangementLayouts.map(
            (layout, beddingIndex) =>
              layout.name && (
                <div key={`beddingInfo-${beddingIndex}`}>
                  {beddingIndex > 0 && (
                    <div className="uitk-type-paragraph-300 all-y-margin-two">
                      <LocalizedText message="hotels.infosite.ratePlan.room.multipleOptions.or.text" />
                    </div>
                  )}
                  <BeddingInfo
                    beddingIcons={layout.icons}
                    heading={sleepingArrangement.sleepingArea}
                    isDialog={isDialog}
                    iconSize={(sleepingArrangement.sleepingArrangementLayouts.length > 1 && UitkIconSize.SMALL) || UitkIconSize.MEDIUM}
                    name={layout.name}
                  />
                </div>
              )
          )}
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
};
Space.displayName = 'Space';
